export const DEFAULT_SNACKBAR_ERROR_MESSAGE =
  "Something went wrong. Please try again.";
